"use strict";
import { miniPortfolioMenuStateAtom } from "components/AccountDrawer/constants";
import ConnectionErrorView from "components/WalletModal/ConnectionErrorView";
import { Option } from "components/WalletModal/Option";
import { useOrderedConnections } from "components/WalletModal/useOrderedConnections";
import { useRecentConnectorId } from "components/Web3Provider/constants";
import { useAtom } from "jotai";
import { useMemo, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { transitions } from "theme/styles";
import { Flex, Separator, Text } from "ui/src";
import { CONNECTION_PROVIDER_IDS } from "uniswap/src/constants/web3";
import { FeatureFlags } from "uniswap/src/features/gating/flags";
import { useFeatureFlag } from "uniswap/src/features/gating/hooks";
import { isMobileWeb } from "utilities/src/platform";
export default function WalletModal() {
  const { t } = useTranslation();
  const isEmbeddedWalletEnabled = useFeatureFlag(FeatureFlags.EmbeddedWallet);
  const [expandMoreWallets, toggleExpandMoreWallets] = useReducer((s) => !s, !isEmbeddedWalletEnabled);
  const [, setMenu] = useAtom(miniPortfolioMenuStateAtom);
  const mainConnectors = useOrderedConnections({ showSecondaryConnectors: false });
  const secondaryConnectors = useOrderedConnections({ showSecondaryConnectors: true });
  const connectors = useMemo(() => {
    const combined = [...mainConnectors, ...secondaryConnectors];
    const seenIds = /* @__PURE__ */ new Set();
    return combined.filter((connector) => {
      if (seenIds.has(connector.id)) {
        return false;
      }
      seenIds.add(connector.id);
      return true;
    });
  }, [mainConnectors, secondaryConnectors]);
  const filteredConnectors = connectors.filter((c) => c.id !== CONNECTION_PROVIDER_IDS.EMBEDDED_WALLET_CONNECTOR_ID);
  const recentConnectorId = useRecentConnectorId();
  const px = 12;
  return <Flex
    backgroundColor="$surface1"
    pt="$spacing16"
    px={px}
    pb="$spacing20"
    flex={1}
    gap="$gap16"
    data-testid="wallet-modal"
  >
      <ConnectionErrorView />
      {
    /* {showDownloadHeader && (
      <Flex display="flex" $md={{ display: 'none' }}>
        <DownloadWalletRow
          onPress={handleOpenGetTheAppModal}
          mx={-8}
          mt={-12}
          width={`calc(100% + ${px * 2 - 8}px)`}
          borderTopLeftRadius="$rounded16"
          borderTopRightRadius="$rounded16"
          iconSize={16}
          titleTextVariant="buttonLabel4"
        />
      </Flex>
    )} */
  }
      <Flex row justifyContent={isEmbeddedWalletEnabled ? "center" : "space-between"} width="100%">
        <Text variant="subheading2">
          {isEmbeddedWalletEnabled ? t("nav.logInOrConnect.title") : t("common.connectAWallet.button")}
        </Text>
      </Flex>
      {
    /* {isEmbeddedWalletEnabled ? (
      <Flex justifyContent="center" alignItems="center" py={8}>
        <img src="/images/logo.webp" width="100" height="40" alt="Logo" />
      </Flex>
    ) : (
      <UniswapWalletOptions />
    )} */
  }
      {
    /* {isEmbeddedWalletEnabled ? null : (
      <Flex
        row
        alignItems="center"
        py={8}
        userSelect="none"
        onPress={toggleExpandMoreWallets}
        {...ClickableTamaguiStyle}
      >
        <Separator />
        <Flex row alignItems="center" mx={18}>
          <Text variant="body3" color="$neutral2" whiteSpace="nowrap">
            <Trans i18nKey="wallet.other" />
          </Text>
          {expandMoreWallets ? (
            <DoubleChevronInverted size={20} color="$neutral3" />
          ) : (
            <DoubleChevron size={20} color="$neutral3" />
          )}
        </Flex>
        <Separator />
      </Flex>
    )} */
  }
      <Flex gap="$gap12">
        <Flex row alignItems="flex-start">
          <Flex
    overflow="hidden"
    width="100%"
    maxHeight={"100vh"}
    opacity={1}
    transition={`${transitions.duration.fast} ${transitions.timing.inOut}`}
    data-testid="option-grid"
  >
            {(recentConnectorId === CONNECTION_PROVIDER_IDS.UNISWAP_WALLET_CONNECT_CONNECTOR_ID || isMobileWeb) && isEmbeddedWalletEnabled && <>
                  <Option connectorId={CONNECTION_PROVIDER_IDS.UNISWAP_WALLET_CONNECT_CONNECTOR_ID} />
                  <Separator />
                </>}
            {filteredConnectors.map((c, index) => <>
                <Option connectorId={c.id} key={c.uid} detected={c.isInjected} />
                {index < filteredConnectors.length - 1 || isEmbeddedWalletEnabled ? <Separator /> : null}
              </>)}
            {
    /* {isEmbeddedWalletEnabled && !isMobileWeb && (
      <Option connectorId={AlternativeOption.OTHER_WALLETS} onPress={() => setMenu(MenuState.OTHER_WALLETS)} />
    )} */
  }
          </Flex>
        </Flex>
        {
    /* <Flex gap="$gap8">
     <Flex px="$spacing4">
       <PrivacyPolicyNotice />
     </Flex>
     {/* {showMoonpayText && (
       <Flex borderTopWidth={1} pt="$spacing8" borderColor="$surface3" px="$spacing4">
         <Text variant="body4" color="$neutral3">
           <Trans i18nKey="moonpay.poweredBy" />
         </Text>
       </Flex>
     )} */
  }
        {
    /* </Flex> */
  }
      </Flex>
      {
    /* {showDownloadHeader && (
      <Flex display="none" $md={{ display: 'flex' }}>
        <DownloadWalletRow
          onPress={handleOpenGetTheAppModal}
          mx={-8}
          mt={-12}
          width={`calc(100% + ${px * 2 - 8}px)`}
          borderTopLeftRadius="$rounded16"
          borderTopRightRadius="$rounded16"
          iconSize={20}
          titleTextVariant="buttonLabel4"
        />
      </Flex>
    )} */
  }
    </Flex>;
}
